/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/vacancies'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import VacanciesPage from '@routes/VacanciesPage';

export const Route = createFileRoute('/vacancies')({
  component: () => <CacheDataRoute component={VacanciesPage} path='/vacancies' />
});
